/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import _ from 'lodash';
import { Control } from 'react-redux-form';
import './styles.css';

/**
 * Render one single checkbox child to be part of the checkbox group
 * @param {*} key The identifying key to help react identify all changes to the element
 * @param {*} value The corresponging value of the checkbox
 * @param {*} displayValue THe displaying value for the checkboxes respective value
 * @param {*} radioProperties The radio button properties for the checkbox
 * @param {*} subText The text to be displayed beneath the checkbox
 */
const renderChild = ({
  key, value, displayValue, radioProperties, subText,
}) => (
  <div styleName="fieldRow">
    <label styleName="radio">
      <Control.radio
        key={key}
        value={value}
        {...radioProperties}
      />
      <span>{displayValue}</span>
      {!_.isEmpty(subText) ? (<span styleName="radioSubText">{subText}</span>) : ('')}
    </label>
  </div>
);

/**
 * Rendex the checkbox group
 * @param {*} props The checkbox group properties to be passed to the respective children
 */
const renderChildren = (props) => {
  let checkboxes;
  const radioProperties = {
    model: props.model,
    defaultValue: props.defaultValue,
    display: props.display,
    label: props.label,
    tooltip: props.tooltip,
    errors: props.errors,
  };

  if (Array.isArray(props.options)) {
    checkboxes = props.options.map(([key, val]) => renderChild({
      key: props.options[key],
      value: props.options[key],
      displayValue: val,
      radioProperties,
      subText: _.isEmpty(props.subTextOptions) ? undefined : props.subTextOptions[key],
    }));
  } else {
    checkboxes = Object.keys(props.options).map(key => renderChild({
      key: props.options[key],
      value: key,
      displayValue: props.options[key],
      radioProperties,
      subText: _.isEmpty(props.subTextOptions) ? undefined : props.subTextOptions[key],
    }));
  }
  return checkboxes;
};

const Component = props => renderChildren(props);

Component.displayName = 'SuitabilityRadioButtonGroup';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Suitability/SuitabilityRadioButtonGroup.js